import { inject, Injectable } from '@angular/core';
import {
  CompanyProgressiveRegistrationRequest,
  CompanyProgressiveRegistrationResponse,
  IdLoginRequest,
  ProgressiveVerificationRequest,
  ProgressiveVerificationResponse,
} from '../interfaces/id-login.model';
import { API_ENDPOINTS } from '../constants/api.constants';
import { ApiResponse } from '../interfaces/api-response.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IdLoginService {
  http: HttpClient = inject(HttpClient);
  /**
   * 個人漸進式登錄驗證
   */
  progressiveverification(
    request: ProgressiveVerificationRequest
  ): Observable<ApiResponse<ProgressiveVerificationResponse>> {
    return this.http.post<ApiResponse<ProgressiveVerificationResponse>>(
      API_ENDPOINTS.PROGRESSIVE_VERIFICATION,
      request
    );
  }

  /**
   * 企業漸進式註冊驗證 (CB-068)
   */
  companyProgressiveRegistration(
    request: CompanyProgressiveRegistrationRequest
  ): Observable<ApiResponse<CompanyProgressiveRegistrationResponse>> {
    return this.http.post<ApiResponse<CompanyProgressiveRegistrationResponse>>(
      API_ENDPOINTS.COMPANY_PROGRESSIVE_REGISTRATION,
      request
    );
  }
}
